'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var loader = require('./loader-8f6b1e8c.js');
var cell = require('./cell-96115b74.js');
var expandIndicator = require('./expand-indicator-71da666c.js');

var StyledCell = styled__default(cell.Cell)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  text-align: center;\n  color: ", ";\n\n  & > div {\n    vertical-align: middle;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  color: ", ";\n\n  & > div {\n    vertical-align: middle;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var LoadingRow = function (_a) {
    var row = _a.row, colSpan = _a.colSpan, dataCy = _a.dataCy, dataTestId = _a.dataTestId;
    if (!row.childRowsLoading || row.childRowsExpanded) {
        return null;
    }
    return (React__default.createElement("tr", { "data-cy": dataCy && dataCy + "-row", "data-testid": dataTestId && dataTestId + "-row" },
        React__default.createElement(StyledCell, { colSpan: colSpan },
            React__default.createElement(expandIndicator.GreyIndicator, null),
            React__default.createElement(loader.Loader, { size: "16px", color: "currentColor" }))));
};
var templateObject_1;

exports.LoadingRow = LoadingRow;
